import { createStore } from "vuex";
import uiSlice from "./modules/uiSlice";
import leadsSlice from "./modules/leadsSlice";
import remindersSlice from "./modules/remindersSlice";
import contactsSlice from "./modules/contactsSlice";
import userSlice from "./modules/userSlice";
import messagesSlice from "./modules/messagesSlice";

const store = createStore({
  modules: {
    uiSlice,
    leadsSlice,
    remindersSlice,
    contactsSlice,
    userSlice,
    messagesSlice,
  },
});

export default store;
